import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventsAdministrationBaseComponent } from './components/events-administration-base/events-administration-base.component';
import { ShowAllEventsComponent } from './components/show-all-events/show-all-events.component';
import { RegistrationPageComponent } from './components/registration-page/registration-page.component';
import { SchemaBrowserComponent } from './components/schema-browser/schema-browser.component';

const routes: Routes = [
  {
    path: "eventsAdmin",
    component: EventsAdministrationBaseComponent,
    children: [
      { path: "show-all-events", component: ShowAllEventsComponent },
      { path: "registration-page", component: RegistrationPageComponent },
      { path: "registration-page/:id", component: RegistrationPageComponent },
      { path: "schema-browser", component: SchemaBrowserComponent },
      { path: "", redirectTo: "show-all-events", pathMatch: "full" },
      { path: "**", redirectTo: "show-all-events" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GfrEventsAdministrationRoutingModule { }
